import styled from 'styled-components'
import globals from '../globals'

export const ContainerWrapper = styled.div`
  max-width: ${globals.maxWidth};
  display: block;
  margin:0 auto;
  padding:0 ${globals.paddingSides.normal};
`